export const generateId = (length) => {
    let text = "";
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++)
        text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
};

export const formatCount = (digit) => {
    const num = Number(digit) || 0;

    if (num < 1000) {
        return num.toString();
    }

    if (num < 1000000) {
        return (num / 1000).toFixed(1).replace('.0', '') + 'K';
    }

    return (num / 1000000).toFixed(1).replace('.0', '') + 'M';
}
